module.exports = __webpack_public_path__ + "img/domains_en.02854078.png";